import { render, staticRenderFns } from "./AcquisitionBoosterButton.vue?vue&type=template&id=50974ab4&"
import script from "./AcquisitionBoosterButton.vue?vue&type=script&lang=js&"
export * from "./AcquisitionBoosterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports